import React from "react";
import "../assets/styles/components/Footer.css";

const Footer = () => {
  return (
    <footer className="footer bg-light text-dark pt-4">
    <div className="container">
      <div className="row">
        
      <hr />
      </div>
      <div className="row">
        {/* Colonne avec l'adresse */}
        <div className="col-md-6 text-center mb-3">
          <h2>ACG-VO</h2>
          <p>11 avenue des Entrepreneurs</p>
          <p>95400 Villiers-le-Bel, Val d'Oise, France</p>
        </div>

        {/* Colonne avec le copyright */}
        <div className="col-md-6 text-center mb-3">
          <h3>Contact</h3>
          <p>Email: acgvo@gmail.com</p>
          <p>Téléphone: +33 (0)1 23 45 67 89</p>
        </div>
      </div>
      <hr />
      <div className="text-center">
        <small>© {new Date().getFullYear()} ACG-VO</small>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
